












import { Component, Prop, Vue } from 'vue-property-decorator'
import linkify from 'linkifyjs/string'

@Component
export default class OrderedList extends Vue {
  @Prop()
  private txt!: string

  private getList(): string[] {
    return this.txt
      .split(/\r?\n/)
      .map(s => s.trim().replace(/^[0-9０-９(\-(\s|　))](\.?)(\s|　)/, ''))
      .filter(s => !!s)
  }

  private convertLinkified(str: string): string {
    return linkify(str)
  }
}
